export default __webpack_public_path__ + "static/media/dubai-american-academy-gems.e510c798.svg";